import { Binding } from "./binding";
/**
 * Describes a style attribute binding
 * @class StyleBinding
 * @extends Binding
 */
export class StyleBinding extends Binding {
    /**
     * Constructs a style binding attribute
     * @param node {INode} the vasille node
     * @param name {string} the name of style property
     * @param value {IValue} the value to bind
     */
    constructor(node, name, value) {
        super(node, name, value);
    }
    /**
     * Generates a function to update style property value
     * @param name {string}
     * @returns {Function} a function to update style property
     */
    bound(name) {
        return function (node, value) {
            if (node.node instanceof HTMLElement) {
                node.app.$run.setStyle(node.node, name, value);
            }
        };
    }
}
